import { useQuery } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import type { IGoodsReceivingService } from '../../../services/goods-receiving';
import { GoodsReceivingService } from '../../../services/goods-receiving';
import { goodsReceivingQueryKeys } from '../query-keys';

/**
 * Hook per recuperare il dettaglio di un singolo DDT.
 * Utilizza TanStack React Query per la gestione dello stato e del caching.
 *
 * @param id - ID del DDT
 * @returns Query result con DeliveryNote o null
 */
export function useDeliveryNoteDetail(id: string) {
  const service = useInjection<IGoodsReceivingService>(GoodsReceivingService);

  return useQuery({
    queryKey: goodsReceivingQueryKeys.noteDetail(id),
    queryFn: async () => {
      return service.findById(id, { includeLots: true });
    },
    enabled: !!id, // Abilita la query solo se l'ID è fornito
  });
}
